import { findIndex } from 'lodash'

export default class Route
{
  constructor(route = {}) {
    this.id = route.id || null
    this.uri = route.uri || ''
    this.controller = route.controller || ''
    this.action = route.action || ''
    this.method = route.method || ''
    this.findings = route.findings || []
    this.bindings = route.bindings || []
    this.middleware = route.middleware || []
    this.vulnerable = route.vulnerable || {}
    this.request_validation = route.request_validation || {}
    this.response_headers = route.response_headers || []
  }

  static mutations() {
    return {
      setRoute: (state, route) => state.route = new Route(route),
      setFalsePositiveOnFinding: (state, payload) => {
        let index = findIndex(state.route.findings, finding => finding.id = payload.findingId)
        let finding = state.route.findings[index]
        finding.false_positive = payload.falsePositive
        state.route.findings.splice(index, 1, finding)
      }
    }
  }
}